import { register } from 'tmr/tmr/ngModuleRegistry'

import * as checklistNotFoundError from 'tmr/services/errors/checklistNotFound'
import * as deviceManagerBadRequestError from 'tmr/services/errors/deviceManagerBadRequestError'
import * as deviceManagerConnectionTimeoutError from 'tmr/services/errors/deviceManagerConnectionTimeoutError'
import * as deviceManagerNotFoundError from 'tmr/services/errors/deviceManagerNotFoundError'
import * as configError from 'tmr/services/errors/configError'
import * as connectionTimeoutError from 'tmr/services/errors/connectionTimeoutError'
import * as invalidCredentialsError from 'tmr/services/errors/invalidCredentialsError'
import * as invalidEpcError from 'tmr/services/errors/invalidEpcError'
import * as invalidFormError from 'tmr/services/errors/invalidFormError'
import * as noActiveWorkstationError from 'tmr/services/errors/noActiveWorkstationError'
import * as workstationAntennasEmptyError from 'tmr/services/errors/workstationAntennasEmptyError'

export default register(
  'tmr.core.services.errors',
  checklistNotFoundError,
  deviceManagerBadRequestError,
  deviceManagerConnectionTimeoutError,
  deviceManagerNotFoundError,
  configError,
  connectionTimeoutError,
  invalidCredentialsError,
  invalidEpcError,
  invalidFormError,
  noActiveWorkstationError,
  workstationAntennasEmptyError
)
